export default __webpack_public_path__ + "static/Entenda0073-8f4f87b21a6036ce0f23094d72c56b79.jpg";